import { mutator, orchestrator } from 'satcheljs';
import { closeCurrentTimeStreamProject } from 'owa-timestream-store';
import { startPanning, finishPanning, pointerMove, pointerUp, resetPanAndZoom } from '../actions';
import getStore from '../store';

function resetPanOffset() {
    getStore().panOffset = null;
}

// Pan by mouse
mutator(startPanning, () => {
    getStore().panOffset = { dx: 0, dy: 0 };
});

mutator(pointerMove, ({ dx, dy }) => {
    const { panOffset } = getStore();
    if (panOffset) {
        panOffset.dx = dx;
        panOffset.dy = dy;
    }
});

orchestrator(pointerUp, () => {
    const { pan, panOffset, hasDraggedFarEnough } = getStore();
    if (panOffset && hasDraggedFarEnough) {
        finishPanning(pan.x + panOffset.dx, pan.y + panOffset.dy);
    }
});

mutator(pointerUp, resetPanOffset);
mutator(resetPanAndZoom, resetPanOffset);
mutator(closeCurrentTimeStreamProject, resetPanOffset);
